var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'status-bar': true}},[_c('el-alert',{staticClass:"status-bar-box",attrs:{"title":_vm.title,"closable":false,"type":_vm.type,"center":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }